
import PropTypes from 'prop-types';

// MUI Table stuff
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

// VMT
import DialogModal from 'components/Modals/DialogModal';


const TableDialogModal = ({ tableHeaderItems, tableContentItems, fieldNames, ...other }) => {
    // const { tableHeaderItems, tableContentItems,  ...other } = props;
    const [keyFieldName, ...dataFieldNames] = fieldNames; // !!! First element MUST be a unique id field name within tableContentItems array of objects

    console.log(tableContentItems);

    return (
        <DialogModal {...other}>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                {/* <TableContainer component={Paper}> */}
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="table items view">
                        <TableHead>
                            <TableRow>
                                {tableHeaderItems.map((headerName) => (
                                    <TableCell key={headerName}>{headerName}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableContentItems.map((row) => (
                                <TableRow
                                    key={row[keyFieldName]}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    {dataFieldNames.map(fieldName => (<TableCell key={`${row[keyFieldName]}-${fieldName}`}>{row[fieldName]}</TableCell>))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </DialogModal>
    );
};

TableDialogModal.propTypes = {
    tableHeaderItems: PropTypes.array.isRequired,
    tableContentItems: PropTypes.array.isRequired,
    fieldNames: PropTypes.array.isRequired,
};

export default TableDialogModal;